const AuthConfig = {
  isValid: () => {
    return !!process.env.COGNITO_POOL_ID && !!process.env.COGNITO_CLIENT_ID;
  }
};

export default AuthConfig;
